import React from 'react';

import { Divider } from '@mui/material';

import { SectionSkeleton } from 'components/shared/MultiStepForm/Skeletons/SectionSkeleton';

import useGetAuxValueById from '../hooks/useGetAuxValueById';
import AuxValuesForm, { IAuxValuesFormProps } from './AuxValuesForm';

interface AuxValuesEditForm extends Omit<IAuxValuesFormProps, 'rowId'> {
  rowId: number | string;
}

const AuxValuesEditForm: React.FC<AuxValuesEditForm> = ({
  handleClose,
  rowId
}) => {
  const { isFetching, resource } = useGetAuxValueById(Number(rowId));
  return isFetching ? (
    <div>
      <SectionSkeleton height={270} width={400} />
      <Divider />
      <SectionSkeleton width={400} />
    </div>
  ) : (
    <AuxValuesForm
      handleClose={handleClose}
      rowId={resource?.auxValueId}
      auxValue={resource}
    />
  );
};

export default AuxValuesEditForm;
